import IobLineItem from "../../../Domain/IobLineItem";
import InputTypesEnum from "../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../Helpers/ValidityHelper";
import IobLineItemService from "../../../Services/IobLineItemService";

class EditIobLineItemWindowDescription {
  static titleForCreate = 'Add New IOB Line Item';
  static titleForEdit = 'Edit IOB Line Item';
  static itemType = IobLineItem;
  static serviceFunction = (edited) => IobLineItemService.UpsertIobLineItem(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Line Item Details',
      fields: [
        {
          fieldName: 'IobinvoiceId',
          label: 'IOB Invoice *',
          className: 'col-6',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'TypeCode',
          label: 'Type *',
          className: 'col-6',
          type: InputTypesEnum.IobLineItemTypeLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Amount',
          label: 'Amount *',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CurrencyName',
          label: 'Currency *',
          className: 'col-6',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          numberOfRows: 2,
        },
      ],
    },
  ];
}

export default EditIobLineItemWindowDescription;